import { useState } from "react";
import { useDispatch } from "react-redux";
import { editPost } from "../action";
import CovidVaccinated from "../covidVaccinated";
import { setResetDropdown } from "../slice";
import Modal from "./modal";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch()
    const edit = (event) => {
        event.preventDefault();
        // dispatch(editPost())
        dispatch(setResetDropdown(false))
        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };

    // console.log(props);
    // console.log( props?.employerJobCovid19VaccinatedIdList);

    return (
        <div className="card h-100">
        {
            showModal && <Modal label={"Covid Vaccination"} showHide={edit} saveFunction={save}>
                <CovidVaccinated errors={props.errors} />
            </Modal>
        }
        <div className="card-header">
                    <b><h5 className="mb-0">Covid 19 Vaccination Status?</h5></b>
                    {
                        props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                            <i className="fe fe-edit" title="Edit Covid Vaccination"></i>
                        </a>
                    }
                </div>
        <div className="card-body">
            <div className="form-group row">
                <>  <div className="col-lg-12 col-md-12">
                    {
                        //props?.covid19Vaccinated?.name                               
                        //created by ram 09/16/2022
                        //employerJobCovid19VaccinatedIdList
                        <label htmlFor="Location Name">{
                         props?.employerCovid19VaccinatedPreferencesList?.map(contact => (contact.name)).join(", ")
                        } </label>
                    }
                   
                </div>
                </>
            </div>
        </div>
    </div>
    )
}
